module.exports = __webpack_public_path__ + "img/relax.d9ab1814.svg";